export default __webpack_public_path__ + "static/media/math-report-bg.3d2de734.png";